<template>
    <nav class="navbar navbar-expand navbar-light bg-white">
        <a class="sidebar-toggle d-flex mr-2" @click="toggleSidebar()">
            <i class="hamburger align-self-center"></i>
        </a>

        <div class="navbar-collapse collapse">
            <ul class="navbar-nav ml-auto">
                <ServerAdministrationBlock v-if="$hasRole('super_admin')" />
                <ServiceDeskNavbar v-if="$hasPermission('servicedesk.requests.create')" />
                <HelpCrm/>
                <CreditCalculator v-if="$hasRole('admin') || $hasRole('operator') || $hasRole('credit_manager') || $hasRole('sales_manager')" />
                <NearestArrival v-if="$hasRole('operator')" />
                <Reminders v-if="showReminders"/>
                <CallHistory v-if="$hasPermission('requests.calls.history.show')"/>
                <UnreadBLock v-if="$hasPermission('requests.chats.send_message')"/>
                <li class="nav-item dropdown">
                    <a class="nav-icon dropdown-toggle d-inline-block d-sm-none" href="#" data-toggle="dropdown">
                        <i class="align-middle" data-feather="settings"></i>
                    </a>

                    <a class="nav-link dropdown-toggle d-none d-sm-inline-block" href="#" data-toggle="dropdown">
                        <img src="https://www.gravatar.com/avatar/15ac38b7dfab4e7276deca54d318323c.jpg?s=50&d=mm"
                             class="avatar img-fluid rounded-circle mr-1" alt="Chris Wood"/> <span class="text-dark">{{ user.name }}</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="#" @click.prevent="logout">Выйти</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Reminders from "./Reminders";
    import ModalCallHistory from "./ModalCallHistory";
    import CallHistory from "./CallHistory";
    import NearestArrival from "./NearestArrival";
    import CreditCalculator from "./credit_calculator/CreditCalculator";
    import HelpCrm from "./HelpCrm";
    import UnreadBLock from "./chats/UnreadBlock.vue";
    import ServerAdministrationBlock from "./server/ServerAdministrationBlock.vue";
    import ServiceDeskNavbar from "./servicedesk/ServiceDeskNavbar.vue";

    export default {
        components: {
            ServiceDeskNavbar,
            ServerAdministrationBlock,
            UnreadBLock, HelpCrm, CreditCalculator, NearestArrival, CallHistory, ModalCallHistory, Reminders},

        data: () => ({
            appName: window.config.appName,
        }),

        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),
            showReminders() {
                return this.$hasPermission('requests.reminders.alerts')
            }
        },

        methods: {
            async logout() {
                await this.$store.dispatch('auth/confirmOnline');

                // Log out the user.
                await this.$store.dispatch('auth/logout');

                // Redirect to login.
                this.$router.push({name: 'login'})
                    .then(() => {
                        window.location.reload();
                    });
            },
            toggleSidebar: function () {
                this.$store.dispatch('sidebar/toggle');
            }
        }
    }
</script>

<style scoped>
    .profile-photo {
        width: 2rem;
        height: 2rem;
        margin: -.375rem 0;
    }
</style>
